import { init as initFullStory, isInitialized as isFullStoryInitialized, FullStory } from '@fullstory/browser'

/**
 * Initialize FullStory with the provided organization ID
 * @param {string} orgId - FullStory organization ID
 */
export const initializeFullstory = (orgId) => {
  try {
    if (orgId) {
      initFullStory({ orgId })
      console.log('FullStory initialized.')
    } else {
      console.log('FullStory org ID not found. Skipping initialization.')
    }
  } catch (error) {
    console.warn('Failed to initialize FullStory:', error)
  }
}

/**
 * Link FullStory customer session with customer information
 * @param {Object} customer - Customer object containing user details
 */
export const linkFullstoryCustomerSession = (customer) => {
  try {
    if (customer?.userId && isFullStoryInitialized()) {
      FullStory('setIdentity', {
        uid: customer.userId,
        properties: {
          displayName: `${customer.firstName} ${customer.lastName}`,
          email: customer.email,
          customerId: customer.id
        }
      })
      console.log('Initialized FullStory customer session.')
    } else {
      console.log('FullStory is not initialized. Skipping customer session initialization.')
    }
  } catch (error) {
    console.warn('Failed to link FullStory customer session:', error)
  }
}
